<script setup lang="ts">
import { useSearchStore } from '@autobid/nuxt-pinia-store/store/searchStore/useSearchStore'
import { storeToRefs } from 'pinia'
import { computed, inject } from 'vue'
import SearchFormChipsContent from './SearchFormChipsContent.vue'

const { chips } = storeToRefs(useSearchStore())

const title = inject('title', '')

const displayingChips = computed(() => {
  return chips.value.filter(item => item.title === title)
})
</script>

<template>
  <div
    v-if="displayingChips.length"
    class="container z-30 mx-auto mt-1 flex w-full flex-row flex-wrap gap-2 whitespace-pre-line bg-black/80 p-4 md:hidden"
  >
    <SearchFormChipsContent :chips="displayingChips" />
  </div>
</template>
